import React from 'react';


const Tour = ({image, title, info, location, date, duration, amount}) => {
  return (
    <article className="tour-card">
        <div className="tour-img-container">
          <img src={image} className="tour-img" alt={title} />
          <p className="tour-date">{date}</p>
        </div>
        <div className="tour-info">
          <div className="tour-title">
            <h4>{title}</h4>
          </div>
          <p>{info}</p>
          <div className="tour-footer">
            <p>
              <span><i className="fas fa-map"></i></span> {location}
            </p>
            <p>{duration} days</p>
            <p>from ${amount}</p>
          </div>
        </div>
      </article>
  )
}

export default Tour